<app-breadcrumb [master]="'Terminale'" [parentName]="'Polisy'" [name]="'Lista'"></app-breadcrumb>
<div class="terminals-list-container">
  <div fxLayout="row">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="terminals-list-filters">
    <ng-container>


      <app-dict-insurance-companies
        [multiple]="true" label="TU" class="terminals-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany"
        name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="false"
        label="Status" class="terminals-list-filter"
        dictType="terminal_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <mat-form-field class="terminals-list-filter">
        <mat-label>Kwota od</mat-label>
        <input matInput placeholder="" name="gte$sum" [(ngModel)]="initialFilters.gte$sum">
      </mat-form-field>
      <mat-form-field class="terminals-list-filter">
        <mat-label>Kwota do</mat-label>
        <input matInput placeholder="" name="lte$sum" [(ngModel)]="initialFilters.lte$sum">
      </mat-form-field>

      <mat-form-field class="terminals-list-filter">
        <mat-label>Numer polisy</mat-label>
        <input matInput placeholder="" name="contains$policyNumber" [(ngModel)]="initialFilters.contains$policyNumber">
      </mat-form-field>

      <mat-form-field class="terminals-list-filter">
        <mat-label>Numer rachunku bankowego</mat-label>
        <input matInput placeholder="" name="contains$accountNumber"
               [(ngModel)]="initialFilters.contains$accountNumber">
      </mat-form-field>

      <app-dict-partners
        [multiple]="false" [label]="'Partner'"
        class="terminals-list-filter terminals-list-filter-long"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <mat-form-field appearance="standard" class="terminals-list-filter">
        <mat-label>Przypisana transakcja</mat-label>
        <mat-select [(ngModel)]="initialFilters.assignedTransaction" name="assignedTransaction">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>


      <app-datepicker
        class="terminals-list-filter"
        label="Data dodania od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$dateAdded" name="gte$dateAdded"
      ></app-datepicker>

      <app-datepicker
        class="terminals-list-filter"
        label="Data dodania do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$dateAdded" name="lte$dateAdded"
      ></app-datepicker>


      <app-datepicker
        class="terminals-list-filter"
        label="Data płatności od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$paymentAt" name="gte$paymentAt"
      ></app-datepicker>

      <app-datepicker
        class="terminals-list-filter"
        label="Data płatności do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$paymentAt" name="lte$paymentAt"
      ></app-datepicker>

    </ng-container>
  </form>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" style="margin-bottom: 15px">
          <button *ngIf="!generate && (userPermissions | async)?.terminals.write" (click)="addTerminal()" class="report-button" mat-raised-button color="primary">
            <mat-icon>add</mat-icon>
            <span> Dodaj transakcję</span></button>

          <button *ngIf="generate && (userPermissions | async)?.terminals.write && totalDataAll>0" (click)="generateFile()" class="report-button" mat-raised-button color="primary">
            <mat-icon>add</mat-icon>
            <span> Generuj plik do banku</span></button>
<!--    <button (click)="generatePayment()" [disabled]="!(userPermissions | async).settlement.read_report" mat-stroked-button ><mat-icon>download</mat-icon> <span> Generuj plik do banku </span></button>-->
<!--    &lt;!&ndash;    <button (click)="importPayment()" [disabled]="!(userPermissions | async).settlement.read_report"  mat-stroked-button  ><mat-icon>publish</mat-icon> <span> Importuj plik z banku </span></button>&ndash;&gt;-->
    <span fxFlex></span>
    <div>
      <app-detail *ngIf="generate" style="position: relative; top: -1px" header="Liczba przelewów do zrealizowania" [value]="totalDataAll.toString()"></app-detail>
    </div>
    <span fxFlex></span>

    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report" mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">


  <table mat-table [dataSource]="terminals" matSort (matSortChange)="sortChanged($event)" [trackBy]="trackTask">
    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link"
           [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{ element.insuranceCompany.name }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="accountNumber">
      <th mat-header-cell *matHeaderCellDef > Numer rachunku bankowego</th>
      <td mat-cell *matCellDef="let element">
        {{ element.accountNumber }}
      </td>
    </ng-container>
    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="policyNumber"> Numer polisy</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" target="_blank"
           [routerLink]="['/terminale/polisy/szczegoly', element.uuid]">{{ element.policyNumber }}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="sum"> Kwota</th>
      <td mat-cell *matCellDef="let element">
        {{ element.sum + " " + "zł" }}
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          <a class="default-link"
             [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{ element.partner?.shortName }}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy?.uuid]">{{element.createdBy?.firstName}} {{element.createdBy?.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateAdded">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dateAdded"> Data dodania</th>
      <td mat-cell *matCellDef="let element">
        {{ element.dateAdded | date: 'yyyy-MM-dd' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payAt">
      <th mat-header-cell *matHeaderCellDef > Data płatności </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.paymentAt | date: 'yyyy-MM-dd' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef > Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{ element.status.name }}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>   </th>
      <td mat-cell *matCellDef="let element" >

        <button
          *ngIf=" (userPermissions | async)?.terminals.write"
          [disabled]="!(userPermissions | async).terminals.write"
          mat-icon-button matTooltip="Zmiana transakcji"  (click)="terminalImportRowChange(element)" color="primary"
        ><mat-icon>edit</mat-icon></button>


      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
</div>


